import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Portal } from 'src/app/models/entities/portal';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';

@Component({
  selector: 'app-portal-add',
  templateUrl: './portal-add.component.html',
  styleUrls: ['./portal-add.component.css']
})
export class PortalAddComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private portalService: PortalService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      portalName: ["", Validators.required],
      portalUrl: [""],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      isActive: true
    })
  }

  add() {
    if (this.form.valid) {
      const portal: Portal = this.form.getRawValue();
      portal.userId=this.userService.getUserId();
      this.portalService.add(portal).pipe(takeUntil(this.destroy$)).subscribe(
        data => {
          this.toastrService.success(data.message, "Başarılı");
          this.router.navigateByUrl('/portal');
        },
        er => {
          this.toastrService.error(er.error.message, "Hata!");
        }
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
